import "react-toastify/dist/ReactToastify.css"

import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { RouterProvider } from "react-router"
import { ToastContainer } from "react-toastify"

import router from "./routes/mainRoute"

import * as Sentry from "@sentry/react"

Sentry.init({
  dsn: "https://fed5972ed0e04052a119edf4c6ba0b3c@o4511410032017408.ingest.de.sentry.io/4511410040209488",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true,
})

const handleLanguageChange = (lng: string) => {
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr"
  window.localStorage.setItem("lang", lng)
}

function App() {
  const { i18n } = useTranslation()

  useEffect(() => {
    // Set initial direction
    i18n.on("languageChanged", handleLanguageChange)

    const lang = window.localStorage.getItem("lang")
    if (lang) {
      i18n.changeLanguage(lang)
      handleLanguageChange(lang)
    }

    return () => {
      i18n.off("languageChanged", handleLanguageChange)
    }
  }, [])

  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer
        position={i18n.language === "ar" ? "top-left" : "top-right"}
        autoClose={2000}
      />
    </>
  )
}

export default App
